import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import PublicationLinks from "../../../../components/Publications/components/PublicationLinks";
import {
  displayVarsomePremiumLogo,
  getVarsoUrl,
} from "../../../../common/helpers/helpers";
import { getIsUserPremium } from "../../../../state/selectors/general.selectors";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import HelperText from "../../../../components/atoms/HelperText";
import { PharmGKBLevelHelperText } from "./PharmGKBLevelHelperText";

const { arrayOf, number, shape, string } = PropTypes;

const CPIC = ({ data, isUserPremium }) => {
  // We are on VarSome and user is Premium or we are on Clinical Platform.
  if (isUserPremium || __IS_COMPONENTS_PORTAL__) {
    if (data && Object.keys(data || {}).length > 0) {
      const content = (
        <div className="varsome-inner-container">
          <table className="varsome-table tw-break-words">
            <thead>
              <tr>
                <th width="15%">Drug</th>
                <th width="10%">Guideline</th>
                <th width="10%">CPIC Level Status</th>
                <th width="10%">CPIC Level</th>
                <th width="10%">Drug ATC IDs</th>
                <th width="10%">Drug RxNorm ID</th>
                <th className="tw-flex-nowrap" width="10%">
                  PharmGKB level of evidence
                  <HelperText RenderContent={() => PharmGKBLevelHelperText} />
                </th>
                <th width="10%">PGx on FDA label</th>
                <th width="15%">Publications</th>
              </tr>
            </thead>
            <tbody>
              {data?.items?.map((item, i) => {
                return (
                  <tr key={i}>
                    <td>{item.drug}</td>
                    {item.guideline ? (
                      <td>
                        <a target="_blank" href={item.guideline}>
                          Guideline
                        </a>
                      </td>
                    ) : (
                      <td>-</td>
                    )}
                    {item.cpic_level_status ? (
                      <td>{item.cpic_level_status}</td>
                    ) : (
                      <td>-</td>
                    )}
                    <td>{item.cpic_level}</td>
                    {item?.drug_atc_ids ? (
                      <td>
                        {item.drug_atc_ids.map((id) => (
                          <a
                            key={id}
                            href={getVarsoUrl(
                              `https://www.whocc.no/atc_ddd_index/?code=${id}`
                            )}
                            target="_blank"
                          >
                            {id}
                          </a>
                        ))}
                      </td>
                    ) : (
                      <td>-</td>
                    )}
                    {item?.drug_rxnorm_id ? (
                      <td>
                        <a
                          href={getVarsoUrl(
                            `https://mor.nlm.nih.gov/RxNav/search?searchBy=RXCUI&searchTerm=${item.drug_rxnorm_id}`
                          )}
                          target="_blank"
                        >
                          {item.drug_rxnorm_id}
                        </a>
                      </td>
                    ) : (
                      <td>-</td>
                    )}
                    {item.pharmgkb_level_of_evidence ? (
                      <td>{item.pharmgkb_level_of_evidence}</td>
                    ) : (
                      <td>-</td>
                    )}
                    {item.pgx_on_fda_label ? (
                      <td>{item.pgx_on_fda_label}</td>
                    ) : (
                      <td>-</td>
                    )}
                    {item.pub_med_references ? (
                      <td>
                        <PublicationLinks ids={item.pub_med_references} />
                      </td>
                    ) : (
                      <td>-</td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
      return (
        <div
          className="varsome-result-fixed"
          id="cpic_component_varsome"
          data-testid="cpic-component"
        >
          <div className="varsome-container varsome-container__basic">
            <ComponentPanel
              title="CPIC"
              version={data?.version}
              url={getVarsoUrl("https://cpicpgx.org/")}
              premiumLogo={displayVarsomePremiumLogo(false)}
              content={content}
            />
          </div>
        </div>
      );
    }
    return null;
  }

  return null;
};

CPIC.propTypes = {
  data: shape({
    items: arrayOf(
      shape({
        cpic_level: string,
        drug: string,
        guideline: string,
        cpic_level_status: string,
        drug_atc_ids: arrayOf(string),
        drug_rxnorm_id: number,
        pgx_on_fda_label: string,
        pharmgkb_level_of_evidence: string,
        pub_med_references: arrayOf(number),
      })
    ),
    version: string,
  }),
  isUserPremium: PropTypes.bool,
};

CPIC.defaultProps = {
  data: null,
  isUserPremium: false,
};

const mapStateToProps = (state) => {
  return {
    isUserPremium: getIsUserPremium(state),
  };
};

export default connect(
  mapStateToProps,
  {}
)(withErrorGuard(CPIC, "CPIC", "CPIC"));
